module.exports = __webpack_public_path__ + "static/img/4015.061f6a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4015.png
// module id = 722
// module chunks = 0 1 12